import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import arraySort from 'array-sort'
import Course from '../Course/Course'
import { useDispatch } from 'react-redux'
import { clearExpandedLevels } from '../../../actions/mycourses'

export const Courses = ({
  mentorMasterCourses,
  academicYears,
  selectedAcademicYearId,
  gradeLevels,
  orgFlags
}) => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(clearExpandedLevels())
  }, [])

  mentorMasterCourses.forEach(mm => (mm.name_sort = mm.name.toUpperCase()))
  return (
    <ol className="activity-courses">
      {arraySort(mentorMasterCourses, ['grade_level_id', 'name_sort']).map(
        mmc => (
          <Course
            activityCourse={mmc}
            academicYears={academicYears}
            key={mmc.id}
            selectedAcademicYearId={selectedAcademicYearId}
            gradeLevels={gradeLevels}
            orgFlags={orgFlags}
          />
        )
      )}
    </ol>
  )
}

Courses.propTypes = {
  mentorMasterCourses: PropTypes.array.isRequired,
  academicYears: PropTypes.array.isRequired,
  selectedAcademicYearId: PropTypes.number.isRequired,
  justAddedCourses: PropTypes.array
}

export default Courses



// WEBPACK FOOTER //
// ./src/components/mycourses/Courses/Courses.js